import React, {useState} from 'react'
import styles from './UIGameHelpButtons.module.scss'
import {useUIGameMyColorContext} from '../../contexts/UIGameMyColorContext'
import {useUIGameSettingsContext} from '../../contexts/UIGameSettingsContext'
import {UIGameHelpFullScreenButton} from './UIGameHelpFullScreenButton'
import {UIGameHelpInformationButton} from './UIGameHelpInformationButton'
import {UIGameHelpRulesButton} from './UIGameHelpRulesButton'
import {UIGameHelpUserSettingsButton} from './UIGameHelpUserSettingsButton'
import {UIGameHelpRulesButtonProvider} from './UIGameHelpRulesButton/UIGameHelpRulesButtonContext'
import {UIGameFullScreenProvider} from './UIGameHelpFullScreenButton/UIGameHelpFullScreenContext'
import {useUIGamePauseContext} from '../UIGamePause/UIGamePauseContext'
import {useUIGameUserSettingsContext} from '../../contexts/UIGameUserSettingsContext'
import {UIGameHelpLeaveGameProvider} from './UIGameHelpLeaveGameContext'
import {useUIGameSocketContext} from '../../contexts/UIGameSocketContext'
import {UIGameHelpInformationPopup} from './UIGameHelpInformationPopup/UIGameHelpInformationPopup'
import {ModeSettingEnum} from '@colonist/types'
import {useUIContext} from '../../contexts/UIContext'

export const UIGameHelpUserSettingsButtonContainer = ({
    isRulesOptionVisible,
    isGameInfoOptionVisible,
    initialCanResign,
}: {
    isRulesOptionVisible: boolean
    isGameInfoOptionVisible: boolean
    initialCanResign: boolean
}) => {
    const {requestPause} = useUIGamePauseContext()
    const {sendDisableKarma} = useUIGameSocketContext()
    const {setIsOpenSettings} = useUIGameUserSettingsContext()
    const {modeSetting, victoryPointsToWin} = useUIGameSettingsContext()
    const {myColor, isMyColorSpectator} = useUIGameMyColorContext()
    const [isOpenGameInfo, setIsOpenGameInfo] = useState(false)

    return (
        <>
            <div className={styles.settingsButtonContainer}>
                <UIGameHelpRulesButtonProvider>
                    <UIGameHelpLeaveGameProvider initialCanResign={initialCanResign}>
                        <UIGameHelpUserSettingsButton
                            isPlayerSpectator={isMyColorSpectator}
                            isRulesOptionVisible={isRulesOptionVisible}
                            isGameInfoOptionVisible={isGameInfoOptionVisible}
                            onSettingsClick={() => setIsOpenSettings(true)}
                            onPauseGameClick={requestPause}
                            onDisableKarmaClick={sendDisableKarma}
                            onGameInfoClick={() => setIsOpenGameInfo(true)}
                        />
                    </UIGameHelpLeaveGameProvider>
                </UIGameHelpRulesButtonProvider>
            </div>
            <UIGameHelpInformationPopup
                isOpen={isOpenGameInfo}
                onClose={() => setIsOpenGameInfo(false)}
                gameMode={modeSetting}
                playerColor={myColor}
                victoryPointsToWin={victoryPointsToWin} />
        </>
    )
}

export const UIGameHelpButtons = ({initialCanResign}: {initialCanResign: boolean}) => {
    const {isUserOnDiscord, isUserOnMobile} = useUIContext()
    const {modeSetting, victoryPointsToWin} = useUIGameSettingsContext()
    const {myColor} = useUIGameMyColorContext()
    const {isOpenSettings} = useUIGameUserSettingsContext()
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    if(isOpenSettings === true) return null
    if(isBeginnerMode === true) return null

    return (
        <div className={styles.container} style={{flexDirection: isUserOnMobile ? 'row' : 'column'}}>
            <UIGameHelpUserSettingsButtonContainer
                initialCanResign={initialCanResign}
                isRulesOptionVisible={false}
                isGameInfoOptionVisible={false}
            />
            <UIGameHelpRulesButtonProvider>
                <UIGameHelpRulesButton />
            </UIGameHelpRulesButtonProvider>
            {isUserOnDiscord === false && <UIGameFullScreenProvider>
                <UIGameHelpFullScreenButton />
            </UIGameFullScreenProvider>}
            <UIGameHelpInformationButton
                gameMode={modeSetting}
                playerColor={myColor}
                victoryPointsToWin={victoryPointsToWin}/>
        </div>
    )
}
